<div class="notice">{{msg}}</div>
